export default __webpack_public_path__ + "static/media/buffing.ed92c43e.png";